<template>
  <div :class="{'ei-word title-bulb':true,'title-bulb-layout':true,active:active} ">
    <div v-if="secondStyle">
      <span :style="'--i:'+index" v-for="(item,index) in wordList" :key="index" class="two">{{ item }}</span>
    </div>
    <div v-else>
      <span :style="'--i:'+index" v-for="(item,index) in wordList" :key="index" class="one">{{item}}</span>
    </div>
  </div>
</template>

<script>
import {toCharList} from './utils/string-util'

export default {
  name: 'EiWord',
  data() {
    return {
      wordList: []
    }
  },
  props: {
    words: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    secondStyle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  },
  watch: {
    words(newV, oldV) {
      this.wordList=toCharList(newV)
    },
  },

  mounted() {
    this.wordList=toCharList(this.words)

  },
}
</script>

<style scoped lang="scss">
.title-bulb {
  font-size: 30px;
  font-weight: bolder;
  color: #333;
  cursor: pointer;


  span {
    transition-duration: .8s;
    transition-delay: calc(var(--i) * .1s);

  }
}

.title-bulb.active {

  .one {
    color: #9F8F37;
    text-shadow: 0 0 10px #fff,
    0 0 20px #fff,
    0 0 30px #fff,
    0 0 50px #fff,
    0 0 80px #fff;
  }

  .two {
    color: #9F8F37;
    text-shadow: 0 0 10px #fff,
    0 0 20px #fff;
    /* 0 0 50px #fff,
     0 0 80px #fff;*/
  }
}
</style>
